import TealiumEventBuilder from '../../analytics/tealium/builders/tealium-event-builder';

const { clone } = require('lodash');

class FulfilmentSelectorDeliveryPickupController {
    constructor(dialogRegistry, settings, addressService, fulfilmentService, fulfilmentSelectorService, analyticsService) {
        this.dialogRegistry = dialogRegistry;
        this.settings = settings;
        this.addressService = addressService;
        this.fulfilmentService = fulfilmentService;
        this.fulfilmentSelectorService = fulfilmentSelectorService;
        this.analyticsService = analyticsService;
    }

    $onInit() {
        this.fulfilmentSelectorService.setModalTitleMessage(this.settings.fulfilmentSelector.fulfilmentMethodSelectorTitle);

        const existingfulfilmentMethodType = this.fulfilmentService.selectedFulfilmentMethod.type;

        // get the selectorFulfilmentOptions object based on existing method
        this.selectedFulfilmentMethod = this.fulfilmentSelectorService.getSelectorFulfilmentOption(existingfulfilmentMethodType);

        // update selectorFulfilmentOptions in service
        this.fulfilmentSelectorService.updateSelectorFulfilmentOptions(existingfulfilmentMethodType);

        this.selectedAddress = this.fulfilmentService.savedAddress;

        this.addressService.getSavedAddresses().then(() => {
            this.savedAddresses = this.addressService.savedAddresses;
        });

        // keep previous values of address and fufilment method in case user submits empty address
        this.previouslySelectedAddress = clone(this.selectedAddress);
        this.previouslySelectedFulfilmentMethod = clone(this.selectedFulfilmentMethod);
    }

    isPickup() {
        return this.selectedAddress
            ? this.selectedFulfilmentMethod.type === this.fulfilmentSelectorService.fulfilmentMethodPickupType
            : this.previouslySelectedFulfilmentMethod.type === this.fulfilmentSelectorService.fulfilmentMethodPickupType;
    }

    addressSelected(address) {
        this.selectedAddress = address;
    }

    onSaveAutoAddress(address) {
        return this.addressService.saveAutoAddress(address).then(response => this.addressSelected(response.Address));
    }

    setFulfilmentMethod(fulfilmentMethod) {
        const event = new TealiumEventBuilder()
            .withScreenName('FulfilmentSelection')
            .withLabel('Fulfilment type toggle')
            .withValue(fulfilmentMethod.name === 'Delivery' ? 'Delivery' : 'Pickup')
            .withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog)
            .withEventName('modal_interaction')
            .build();

        this.analyticsService.push(event);
        this.selectedFulfilmentMethod = fulfilmentMethod;
        this.selectedAddress = null;

        this.fulfilmentSelectorService.updateSelectorFulfilmentOptions(fulfilmentMethod.type);
    }

    saveFulfilment() {
        const event = new TealiumEventBuilder()
            .withScreenName('FulfilmentSelection')
            .withLabel('Button/link click')
            .withValue('Next')
            .withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog)
            .withEventName('modal_interaction')
            .build();

        this.analyticsService.push(event);
        // save address for future use
        this.fulfilmentService.saveFulfilment({
            fulfilmentMethod: this.isPickup() ? 'Pickup' : 'Courier',
            address: this.selectedAddress ? this.selectedAddress : this.previouslySelectedAddress,
            fulfilmentWindow: { time: null },
            billingAddressId: null,
        });

        // set up fulfilment method and address for right hand panel
        this.fulfilmentService.selectedFulfilmentMethod = this.isPickup()
            ? this.fulfilmentService.fulfilmentOptions.pickup
            : this.fulfilmentService.fulfilmentOptions.delivery;

        this.fulfilmentService.savedAddress = this.selectedAddress ? this.selectedAddress : this.previouslySelectedAddress;

        // switch to start shopping screen
        this.fulfilmentSelectorService.currentStep = this.fulfilmentSelectorService.fulfilmentSelectorSteps.startShopping;

        if (this.fulfilmentSelectorService.shouldEnableFulfilmentSelectorStartShopping) {
            this.fulfilmentSelectorService.setUserPreferenceFulfilmentSelectorStepStartShopping(true);
        }
    }

    confirmLater() {
        const dialog = this.dialogRegistry.getDialog('fulfilment-selector-dialog');
        const event = new TealiumEventBuilder()
            .withScreenName('FulfilmentSelection')
            .withLabel('Button/link click')
            .withValue('Confirm later')
            .withEventName('modal_interaction')
            .build();
        this.analyticsService.push(event);

        if (dialog) {
            dialog.close();
        }
    }

    onKeyPress($event, option) {
        if ($event && $event.keyCode === 13) {
            this.setFulfilmentMethod(option);

            event.preventDefault();
        }
    }
}

FulfilmentSelectorDeliveryPickupController.$inject = ['DialogRegistry', 'Settings', 'AddressService', 'FulfilmentService', 'FulfilmentSelectorService', 'AnalyticsService'];

const fulfilmentSelectorDeliveryPickupComponentDefinition = {
    controller: FulfilmentSelectorDeliveryPickupController,
    template: require('./fulfilment-selector-delivery-pickup.component.html').trim(),
};

module.exports = {
    FulfilmentSelectorDeliveryPickupController,
    fulfilmentSelectorDeliveryPickupComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/fulfilment/fulfilmentselector/fulfilment-selector-delivery-pickup.component.js